export const STATISTICS_PAGE_DATA_RESOLVED = 'STATISTICS_PAGE_DATA_RESOLVED';
export const STATISTICS_PAGE_DATA_FAILED = 'STATISTICS_PAGE_FETCH_FAILED';
export const STATISTICS_PAGE_HIDE_LOADING = 'STATISTICS_PAGE_HIDE_LOADING';
export const STATISTICS_PAGE_URL = '/statistics';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/routes/Statistics/constants.js